import { render, staticRenderFns } from "./card.vue?vue&type=template&id=18fb23ed"
import script from "./card.js?vue&type=script&lang=js&external"
export * from "./card.js?vue&type=script&lang=js&external"
import style0 from "./card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports